import React from 'react'

const ManageMyBooking = () => {
  return (
    <section className='component-manage_my_booking relative mx-auto max-w-screen-xl py-2 px-4'>
      <form
        className='w-full flex-row items-end bg-orange-500 p-4 text-white md:flex'
        method='get'
        rel='sponsored'
        acceptCharset='UTF-8'
        action='https://secure.parking4less.com/viewamendcancel/c/viewBooking?request=7&amp;page=view&amp;referrer=https://www.parking4less.com/'>
        <input name='agent' type='hidden' defaultValue='wx372' />
        <input name='product' type='hidden' defaultValue='gen' />
        <input name='request' type='hidden' defaultValue='7' />
        <div className='relative w-full lg:mx-1 lg:w-1/3'>
          <label className='mb-1 block font-normal text-white' htmlFor='BookingRef'>
            Booking Reference
          </label>
          <input name='BookingRef' id='BookingRef' size='30' type='text' className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700' />
        </div>
        <div className='relative mt-4 w-full md:mt-0 lg:mx-1 lg:w-1/3'>
          <label className='mb-1 block font-normal text-white' htmlFor='Email'>
            Email Address
          </label>
          <input name='Email' id='Email' size='30' type='email' className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700' />
        </div>
        <div className='relative mt-4 w-full md:mt-0 lg:mx-1 lg:w-1/3'>
          <button type='submit' class='button h-12 w-full'>
            View / Amend Booking
          </button>
        </div>
      </form>
    </section>
  )
}

export default React.memo(ManageMyBooking)
